import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-4 mb-4"
}
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "text-lg font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "chip-primary-outline"
}
const _hoisted_6 = {
  key: 1,
  class: "chip-purple-outline"
}
const _hoisted_7 = {
  key: 2,
  class: "chip-green-outline"
}
const _hoisted_8 = {
  key: 3,
  class: "chip-red-outline"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-base mt-1" }, "Berikut adalah detail transaksi pembayaran untuk batch tersebut.", -1)
const _hoisted_10 = { class: "fuel-payment-batch-detail-table mb-6" }
const _hoisted_11 = { class: "w-full table-variant text-neutral500 px-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs" }, "Pom"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs w-150px" }, "Bank"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs" }, "No. Rekening"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs" }, "Atas Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs" }, "Nominal")
  ])
], -1)
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center font-bold text-lg" }, "Total")
], -1)
const _hoisted_20 = { class: "text-center font-bold text-lg" }
const _hoisted_21 = { class: "flex items-center justify-end" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Kembali")

import apiUseCase from '@/usecase/apiUseCase'
import numberFormat from '@/utils/helpers/numberFormat'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import moment from 'moment'
import Button from 'primevue/button'
import { computed, onMounted, ref, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import VehicleTransaction from './VehicleTransaction.vue'
import CrewTransaction from './CrewTransaction.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchPaymentDetail',
  props: {
  data: {
    default: () => null as any
  },
},
  emits: ["hideDialog"],
  setup(__props, { emit }: { emit: ({
  (e: 'hideDialog'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props




const data = computed(() => props.data)

const endpoint = '/transaction/v2/FuelingTransactions'
const endpointBatch = '/transaction/v2/FuelingPaymentBatches'
const store = useStore()
const route = useRoute()
const dataHeader = ref(null) as any
const dataParent = ref(null) as any
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const tabList = ref([
  { title: 'Nopol', value: 0, hasCount: false, count: 0 },
  { title: 'Kru', value: 1, hasCount: false, count: 0 },
])
const currTabIndex = ref(0)

const onPrintAct = async (item: any) => {
  // console.log('print', item)
  // console.log('parent', dataParent.value)
  store.dispatch('showLoading')
  const payload = {}
  await apiUseCase.getBlob(`${endpointBatch}/${dataParent.value.Id}/Export`).then((response) => {
    const { error, result } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data berhasil didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
      const blob = result
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Bukti Transaksi BBM ${dataParent.value.Code} (${moment().format('DD MMMM YYYY')}).pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Data gagal didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const truncateText = (text:any, maxLength = 10) => {
  if (!text) return ''
  return text.length > maxLength ? `${text.slice(0, maxLength)}...`
    : text
}

const getData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${endpointBatch}/${data.value.Id}`).then((response) => {
    console.log('res', response)
    const { error, result } = response
    if (!error) {
      dataHeader.value = result
    }
  })
  store.dispatch('hideLoading')
}

const tabsChange = (val: any, index: any) => {
  console.log('change', [val, index])
  currTabIndex.value = index
}

const closeDialog = () => {
  emit('hideDialog')
}

const getTotalPayment = (list: any) => rupiahFormat(Math.abs(list.reduce((sum: any, item: any) => sum + item.TotalAmount, 0)))

onMounted(() => {
  console.log('data', data.value)
  // dataParent.value = encryptDecriptMethods.decrypt(route.params.id).data
  getData()
})

return (_ctx: any,_cache: any) => {
  return (_unref(dataHeader))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(`${_unref(dataHeader).Code}(${_unref(moment)(_unref(dataHeader).CreatedAt).format('DD MMMM YYYY HH:mm:ss')})`), 1),
            (_unref(dataHeader).Status === 'Paid')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(dataHeader).StatusDisplayName), 1))
              : _createCommentVNode("", true),
            (_unref(dataHeader).Status === 'Refund' || _unref(dataHeader).Status === 'CompletedWithRefund')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(dataHeader).StatusDisplayName), 1))
              : _createCommentVNode("", true),
            (_unref(dataHeader).Status === 'Completed' || _unref(dataHeader).Status === 'Done')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(dataHeader).StatusDisplayName), 1))
              : _createCommentVNode("", true),
            (_unref(dataHeader).Status === 'Pending')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(dataHeader).StatusDisplayName), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("table", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("tbody", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataHeader)?.FuelStationPartners, (data) => {
                return (_openBlock(), _createElementBlock("tr", { key: data }, [
                  _createElementVNode("td", _hoisted_14, _toDisplayString(data.Name ?? '-'), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(data.MsBankName ?? '-'), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(data.AccountNumber ?? '-'), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(data.AccountName ?? '-'), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(rupiahFormat)(Math.abs(data.TotalAmount ?? 0))), 1)
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _hoisted_19,
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(getTotalPayment(_unref(dataHeader)?.FuelStationPartners)), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog()))
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})